import NotificationService from 'App/babel/NotificationService';

// `errorTranslated` is appended verbatim to the translated body by
// SystemNotificationReducer — it doesn't run through $translate, so we use it
// to surface raw server error messages safely.
type NotificationConfig = {
	icon: string;
	style: string;
	title: string;
	body: string;
	errorTranslated?: string;
};

// Toasts a failed AI workspace API request and logs the raw error for devs.
export const notifyAIWorkspaceError = (err: unknown, context?: string): void => {
	const message = err instanceof Error ? err.message : err == null ? '' : String(err);
	console.error(`[AIWorkspace${context ? `:${context}` : ''}]`, err);
	const config: NotificationConfig = {
		icon: 'times',
		style: NotificationService.style.ERROR,
		title: 'assistant.apiErrorTitle',
		body: 'assistant.apiErrorBody',
		errorTranslated: message
	};
	NotificationService.add(config);
};
